import moment from "moment";

export const columns = [
  { 
    field: "orderId", 
    header: "Order Id",
    accessor: (row,handleCellClick) => (
        <>
          <div onClick={()=>handleCellClick(row,"orderId")}  className="cursor-pointer text-blue-600 hover:text-blue-800">
            <p>{row?.orderId?.order_id}</p>            
          </div>
        </>
      ),

   },
  { field: "date", header: "Date" ,
    accessor: (row,handleCellClick) => (
      <>
        <div onClick={()=>handleCellClick(row,"date")} >          
          <p className="w-[10rem]">
            {moment(row?.date).utc().format("DD MMM YYYY hh:mma")}
          </p>
        </div>
      </>
    ),
  },
  { 
    field: "product", 
    header: "Product",
    accessor: (row,handleCellClick) => (
        <>
          <div onClick={()=>handleCellClick(row,"orderId")}  className="cursor-pointer text-blue-600 hover:text-blue-800">
            <p className="truncate w-[8rem]">{row?.orderDetails?.product?.name}</p>            
          </div>
        </>
      ),

   },
  
  { field: "total", header: "Total",
    accessor: (row,handleCellClick) => (
      <>
        <div onClick={()=>handleCellClick(row,"total")}>          
          <p className="px-2">
           {parseFloat(row?.total).toFixed(2)}
          </p>
        </div>
      </>
    ),
   },
  { field: "storeEarn", header: "Store Earn",
    accessor: (row,handleCellClick) => (
      <>
        <div onClick={()=>handleCellClick(row,"total")}>          
          <p className="px-2">
           {parseFloat(row?.storeEarn).toFixed(2)}
          </p>
        </div>
      </>
    ),
   },
  { field: "deliverymanEarn", header: "Delivery Man Earn",
    accessor: (row,handleCellClick) => (
      <>
        <div onClick={()=>handleCellClick(row,"total")}>          
          <p className="px-2">
           {parseFloat(row?.deliverymanEarn).toFixed(2)}
          </p>
        </div>
      </>
    ),
   },
  { field: "adminEarn", header: "Admin Earn",
    accessor: (row,handleCellClick) => (
      <>
        <div onClick={()=>handleCellClick(row,"total")}>          
          <p className="px-2">
           {parseFloat(row?.adminEarn).toFixed(2)}
          </p>
        </div>
      </>
    ),
   },
];


export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };
  
  export  const filters = [
    {
      filterType: "Delivery Type",
      inputName: "orderId.order_type",
      options: [
        {
          name: "Local delivery",
          code: "LOCAL DELIVERY",
        },
        {
          name: "Intercity delivery",
          code: "INTERCITY DELIVERY",
        },
      ],
    },
    {
      filterType: "Payment Mode",
      inputName: "orderId.pay_type",
      options: [
        {
          name: "Cash",
          code: "CASH",
        },
        {
          name: "Card",
          code: "CARD",
        },
        {
          name: "Online",
          code: "ONLINE",
        },      
      ],
    },
    {
      filterType: "Payment Status",
      inputName: "orderId.payment_status",
      options: [
        {
          name: "UNPAID",
          code: "UNPAID",
        },
        {
          name: "PAID",
          code: "PAID",
        },
        {
          name: "FAILED",
          code: "FAILED",
        },      
        {
          name: "PENDING",
          code: "PENDING",
        },      
      ],
    },
    {
      filterType: "Delivery Status",
      inputName: "orderDetails.delivery_status",
      options: [
        {
          name: "WAITING",
          code: "WAITING",
        },
        {
          name: "ACCEPTED",
          code: "ACCEPTED",
        },
        {
          name: "PREPARED",
          code: "PREPARED",
        },      
        {
          name: "READY",
          code: "READY",
        },      
        {
          name: "ASSIGNED",
          code: "ASSIGNED",
        },      
        {
          name: "CANCELLED",
          code: "CANCELLED",
        },      
        {
          name: "REPLACED",
          code: "REPLACED",
        },      
        {
          name: "RETURNED",
          code: "RETURNED",
        },      
        {
          name: "DELIVERED",
          code: "DELIVERED",
        },      
        {
          name: "REJECTED",
          code: "REJECTED",
        },      
      ],
    },
  ]
  
  export const canlenderFilter={
    filterType:"Order Date",
    inputName:"orderId.order_date",  
    maxDate :new Date()
  }